import React from 'react';

// Professional fallback icons for different model types and workflows
// Props: type, size (default 110), style
export function FallbackIcon({ type = 'default', size = 110, style = {} }) {
  const getIconConfig = (modelType) => {
    const configs = {
      // Image-related types
      image: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21,15 16,10 5,21"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#3b82f6'
      },
      'image-generation': {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21,15 16,10 5,21"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#3b82f6'
      },
      'image-upscaler': {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <path d="M9 9l6 6"/>
            <path d="m15 9-6 6"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#3b82f6'
      },
      'background-remover': {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <path d="M8 8l8 8"/>
            <path d="m16 8-8 8"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: '#f59e0b'
      },
      // Text-related types
      text: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14,2 14,8 20,8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10,9 9,9 8,9"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: '#10b981'
      },
      'text-generation': {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14,2 14,8 20,8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10,9 9,9 8,9"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: '#10b981'
      },
      video: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="23 7 16 12 23 17 23 7"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: '#f59e0b'
      },
      audio: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
        color: '#8b5cf6'
      },
      workflow: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="6" height="6" rx="1"/>
            <rect x="15" y="3" width="6" height="6" rx="1"/>
            <rect x="9" y="15" width="6" height="6" rx="1"/>
            <path d="M6 9v3a3 3 0 0 0 3 3h6"/>
            <path d="M18 9v3a3 3 0 0 1-3 3h-6"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #ec4899 0%, #be185d 100%)',
        color: '#ec4899'
      },
      chat: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            <path d="M8 10h8"/>
            <path d="M8 14h6"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        color: '#06b6d4'
      },
      default: {
        icon: (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        ),
        gradient: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
        color: '#6b7280'
      }
    };

    // Try exact match first, then partial matches
    if (configs[modelType]) {
      return configs[modelType];
    }
    
    // Try partial matches for common patterns
    const lowerType = modelType?.toLowerCase() || '';
    
    if (lowerType.includes('image') || lowerType.includes('vision')) {
      return configs.image;
    }
    if (lowerType.includes('text') || lowerType.includes('language') || lowerType.includes('chat')) {
      return configs.text;
    }
    if (lowerType.includes('video')) {
      return configs.video;
    }
    if (lowerType.includes('audio') || lowerType.includes('speech')) {
      return configs.audio;
    }
    if (lowerType.includes('workflow')) {
      return configs.workflow;
    }
    
    return configs.default;
  };

  const config = getIconConfig(type?.toLowerCase());

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minWidth: size,
        minHeight: size,
        background: config.gradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        ...style
      }}
    >
      {/* Subtle pattern overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.1) 0%, transparent 50%)`,
          pointerEvents: 'none'
        }}
      />
      
      {/* Icon */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        {config.icon}
      </div>
      
      {/* Subtle glow effect */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(circle at center, ${config.color}20 0%, transparent 70%)`,
          pointerEvents: 'none'
        }}
      />
    </div>
  );
}
